// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
// import '../static/fonts/font.css';
import './assets/css/style.css';
import './assets/css/animate.min.css';

import './assets/js/jquery-1.9.1.min.js';
import './assets/js/mobile.js';
import './assets/js/common.js';

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'


// 全局引入Toast
import './components/Toast/toast.css';
import Toast from './components/Toast/index';

import api from'./api/api.js';//接口方法名称
import utils from './utils/utils.js';//工具方法
import VueCookies from 'vue-cookies';//存储


//图片预览
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
Vue.use (VueImageSwipe);

// 1.全局引用
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer)

// vue监听手指滑动vue-touch的使用
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})


import './assets/css/index.css';

import Request from './utils/request' // 引入封装的文件 - 请求接口方法
const { request, baseURL } = Request;
Vue.prototype.$http = request;
Vue.prototype.baseURL = baseURL;

Vue.prototype.api = api;
Vue.prototype.utils = utils;
Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(Toast);


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


//npm i element-ui -S

//npm install swiper@3 --save-dev

//npm install --save axios vue-cookies

//npm install vue-social-share -S

//npm install vue-video-player -S


//npm install weixin-js-sdk --save


//npm install vue-touch@next --save  vue监听手指滑动vue-touch的使用

//npm install better-scroll --save  下拉刷新， 上拉加载
//npm install @better-scroll/pull-up --save




// WEBPACK FOOTER //
// ./src/main.js